import { api } from '../api';

export type DiscountType = 'percentage' | 'fixed';

export type Coupon = {
  id: string;
  code: string;
  event_id: string;
  discount_type: DiscountType;
  discount_value: number;
  max_uses?: number;
  current_uses: number;
  valid_from?: string;
  valid_until?: string;
  is_active: boolean;
  min_ticket_value?: number;
  ticket_types?: string[];
  description?: string;
  created_at: string;
  updated_at: string;
  event?: {
    id: string;
    title: string;
  };
};

export type CreateCouponData = {
  code: string;
  event_id: string;
  discount_type: DiscountType;
  discount_value: number;
  max_uses?: number;
  valid_from?: string;
  valid_until?: string;
  is_active?: boolean;
  min_ticket_value?: number;
  ticket_types?: string[];
  description?: string;
};

export type UpdateCouponData = Partial<CreateCouponData>;

export type CouponListResponse = {
  success: boolean;
  data: Coupon[];
  total: number;
  page: number;
  limit: number;
};

export type ValidateCouponResult = {
  success: boolean;
  message: string;
  discountAmount?: number;
  finalValue?: number;
  couponId?: string;
  discountType?: DiscountType;
  discountValue?: number;
};

export const couponService = {
  // CRUD (admin)
  create: (data: CreateCouponData) => 
    api.post<{ success: boolean; data: Coupon }>('/coupons', data),
  
  update: (id: string, data: UpdateCouponData) => 
    api.put<{ success: boolean; data: Coupon }>(`/coupons/${id}`, data),
  
  get: (id: string) => 
    api.get<{ success: boolean; data: Coupon }>(`/coupons/${id}`),
  
  list: (page = 1, limit = 15, eventId?: string) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (eventId) {
      params.append('event_id', eventId);
    }

    return api.get<CouponListResponse>(`/coupons?${params.toString()}`);
  },
  
  delete: (id: string) => 
    api.delete<{ success: boolean }>(`/coupons/${id}`),

  // Validação pública (formulário de inscrição)
  validate: (code: string, eventId: string, ticketType?: string, ticketValue?: number) =>
    api.post<ValidateCouponResult>('/coupons/validate', {
      code,
      event_id: eventId,
      ticket_type: ticketType,
      ticket_value: ticketValue
    }),
};

